import http from './http'

function getTags () {
  return http({
    method: 'GET',
    url: '/tags'
  })
}

function createTag (value) {
  return http({
    method: 'POST',
    url: '/tags',
    data: {
      value
    }
  })
}

function deleteTag (id) {
  return http({
    method: 'DELETE',
    url: '/tags/' + id
  })
}

function editTag (id, value) {
  return http({
    method: 'PUT',
    url: '/tags/' + id,
    data: {
      value
    }
  })
}

export {
  getTags,
  createTag,
  deleteTag,
  editTag
}



// WEBPACK FOOTER //
// ./src/services/api/tag.js